var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsLogoPrismWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 21,
    viewBox: "0 0 63 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_6728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0022 16.0999L42.714 6.71571H34.1424V4.8999H46.8654L38.1536 14.2853H46.8841V16.0999H34.0022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9979 4.8999H29.8357V16.0999H31.9979V4.8999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0177 16.0999V7.78265L56.0155 13.1526L51.0296 7.78265V16.0999H49.0486V4.8999H50.8426L55.9933 10.4447L61.179 4.8999H62.9999V16.0999H61.0177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0999V10.4248H9.23542C10.2546 10.4248 11.0832 9.59259 11.0832 8.56907C11.0832 7.54555 10.2546 6.71336 9.23542 6.71336H0V4.8999H9.23542C11.2492 4.8999 12.8877 6.54551 12.8877 8.5679C12.8877 10.5903 11.2492 12.2359 9.23542 12.2359H1.80571V16.0987H0V16.0999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 16.0999L21.6124 12.2371H16.6031V16.0999H14.7986V10.4248H19.9294L14.7986 4.8999H24.1988C26.2125 4.8999 27.8523 6.54551 27.8523 8.56907C27.8523 10.5926 26.3481 12.1103 24.429 12.23L24.0936 12.2511L27.6676 16.0999H25.1992ZM22.3966 10.4248H24.1976C25.2168 10.4248 26.0454 9.59259 26.0454 8.56907C26.0454 7.54555 25.2168 6.71336 24.1976 6.71336H18.9488L22.3966 10.426V10.4248Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_6728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 11.2,
    fill: "white",
    transform: "translate(0 4.8999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsLogoPrismWh);
export default __webpack_public_path__ + "static/media/BS_logo_prism_wh.bab6a66e0a3201f171e498d8753ba8c6.svg";
export { ForwardRef as ReactComponent };